import { render, staticRenderFns } from "./ReservePaymentDetailsWidget.vue?vue&type=template&id=2d6f5670"
import script from "./ReservePaymentDetailsWidget.vue?vue&type=script&lang=js"
export * from "./ReservePaymentDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports